<template>
    <div>
        <v-overlay :model-value="loading"
                   class="align-center justify-center">
            <v-progress-circular color="primary"
                                 indeterminate
                                 size="64"></v-progress-circular>

        </v-overlay>
        <div v-if="data" class="pa-2">
            <h2>{{ data.year }}</h2>
            <div v-for="group in data.contactGroups" :key="group.groupName" class="mb-3 pb-3">
                <v-table density="compact" class="my-2 py-2 border-t-md border-b-md">
                    <tbody>
                        <tr>
                            <td style="width:25%">
                                <v-chip variant="flat" :color="groupDetails(group.groupName).colour" size="large">
                                    <v-icon start :icon="groupDetails(group.groupName).icon"></v-icon> {{ group.groupName }}
                                </v-chip>
                            </td>
                            <td class="text-right" style="width:15%">
                                <small>ACTUAL</small>
                                <h2>{{ numberWithCommas(groupActual(group), 0) }}</h2>
                            </td>
                            <td class="text-right" style="width:15%">
                                <small>ESTIMATE</small>
                                <h2>{{ numberWithCommas(groupEstimate(group), 0) }}</h2>
                            </td>
                            <td class="text-right" style="width:15%">
                                <small>BUDGET</small>
                                <h2>{{ numberWithCommas(groupBudget(group), 0) }}</h2>
                            </td>
                            <td class="text-right" style="width:10%">
                                <small>% DIFF.</small>
                                <h2>{{ groupBudget(group) ? numberWithCommas(groupPercentDiff(group), 0) + '%' : '0' }}</h2>
                            </td>
                        </tr>
                    </tbody>
                </v-table>
                <v-table density="compact">
                    <thead>
                        <tr>
                            <th class="text-left" style="width:25%">
                                Name
                            </th>
                            <th class="text-right" style="width:15%">
                                Actual YTD
                            </th>
                            <th class="text-right" style="width:15%">
                                Actual Estimate
                            </th>
                            <th class="text-right" style="width:15%">
                                Budget {{ data.year }}
                            </th>
                            <th class="text-right" style="width:10%">% Diff.</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in group.contacts" :key="item.contact.id">
                            <td><contact-link :contact="item.contact"></contact-link></td>
                            <td class="text-right">{{ numberWithCommas(item.activeBudget.ytdActual, 0) }}</td>
                            <td class="text-right">{{ numberWithCommas(item.activeBudget.estimatedActual, 0) }}</td>
                            <td class="text-right"><span v-if="item.activeBudget.budget">{{ numberWithCommas(item.activeBudget.budget, 0) }}</span></td>
                            <td class="text-right"><span v-if="item.activeBudget.percentageDifference">{{ numberWithCommas(item.activeBudget.percentageDifference, 0) }}%</span></td>
                        </tr>
                    </tbody>
                </v-table>
            </div>
        </div>
    </div>
</template>
<style scoped>
</style>
<script>
    import { numberWithCommas } from "../../mixins/numberMixins";
    function initialState() {
        return {
            loading: false,
            saving: false,
            data: null,
            loaded: false,
        };
    }
    export default {
        name: "BudgetReport",
        data: function () {
            return initialState();
        },
        mounted: function () {
            this.loadReport();
        },
        props: {
            definition: Object
        },
        components: {
        },
        methods: {
            loadReport(){
                this.errors = null;
                // All good - Run
                this.loading = true;
                let query = [];
                this.$api.get(this.definition.route)
                    .then(res => {
                        this.loading = false;
                        this.data = res.data;
                        this.buildGraphData();
                    }).catch(error => {
                        this.loading = false;
                    });
            },
            numberWithCommas,
            groupActual(group) {
                return group.contacts.reduce((sum, c) => sum + (c.activeBudget.ytdActual || 0), 0);
            },
            groupEstimate(group) {
                return group.contacts.reduce((sum, c) => sum + (c.activeBudget.estimatedActual || 0), 0);
            },
            groupBudget(group) {
                return group.contacts.reduce((sum, c) => sum + (c.activeBudget.budget || 0), 0);
            },
            groupPercentDiff(group) {
                const estimate = this.groupEstimate(group);
                const budget = this.groupBudget(group);
                if (!budget) return 0;
                return ((estimate - budget) / budget) * 100;
            },
            groupDetails(groupName) {
                switch (groupName) {
                    case "Managed":
                        return { name: groupName, colour: "indigo-lighten-1", icon: 'mdi-strategy' };
                    case "Standard":
                        return { name: groupName, colour: "blue-grey-lighten-1", icon: 'mdi-clipboard-account' };
                    case "Transactional":
                        return { name: groupName, colour: "brown-lighten-1", icon: 'mdi-invoice-fast-outline' };
                }
            }
        },
        computed: {
        }
    };
</script>